import React from 'react';
import useFilterModalContext from '../../useFilterModalContext';
import useSearchParams from '../../../../useSearchParams';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {query, setQuery} = useSearchParams();

  const hasScoreFilter = query?.prospectScore?.from || query?.prospectScore?.to;
  const hasRankFilter = query?.totalScoreRanks?.length > 0;

  if (!hasScoreFilter && !hasRankFilter) {
    return null;
  }

  const getRankLabels = () => {
    const rankLabels: {[key: string]: string} = {
      a: 'A',
      b: 'B',
      c: 'C',
      d: 'D',
    };
    return (query.totalScoreRanks || []).map(
      (rank: string) => rankLabels[rank],
    );
  };

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">顧客スコア</h4>
        <button
          onClick={() => setFilterType('prospectScore')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() =>
            setQuery({
              ...query,
              prospectScore: {},
              totalScoreRanks: [],
            })
          }
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex flex-col gap-2">
        {hasRankFilter && (
          <div className="flex items-center gap-2">
            <span className="text-sm text-c-light">ランク:</span>
            <div className="flex flex-wrap gap-1">
              {getRankLabels().map((label) => (
                <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
                  {label}
                </span>
              ))}
            </div>
          </div>
        )}
        {hasScoreFilter && (
          <div>
            <span className="text-sm text-c-light mr-2">スコア:</span>
            {query.prospectScore.from && (
              <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
                {query.prospectScore.from}
              </span>
            )}
            <span className="text-c-light px-2">~</span>
            {query.prospectScore.to && (
              <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
                {query.prospectScore.to}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
